import React from 'react';
export function DisclaimerFooter() {
  return <footer className="w-full bg-navy-950 px-5 pb-32 pt-12" data-id="element-158" data-mp="2xbcbihjd82r4">
      <div className="mx-auto max-w-3xl text-center" data-id="element-159" data-mp="2smalrd6pbpiy">
        <p className="font-display text-lg font-bold uppercase tracking-wide text-slate-300" data-id="element-160" data-mp="2siwlcahllqe5">Important Educational Disclaimer</p>
        <div className="mt-4 space-y-3 text-sm leading-relaxed text-slate-400" data-id="element-161" data-mp="32bk9yhyfco1s">
          <p data-id="element-162" data-mp="37af60llek93u">
            Low Back Pain Assessment Blueprint™ is an educational resource intended to support professional learning and the organization of
            musculoskeletal assessment concepts.
          </p>
          <p data-id="element-163" data-mp="3gak23zl5bl2p">
            It does not guarantee diagnostic accuracy or clinical outcomes. It does not replace professional education, supervised clinical
            training, individualized patient assessment, professional judgment, current clinical guidelines, emergency procedures, or appropriate
            medical referral.
          </p>
          <p data-id="element-164" data-mp="1qw5gho5fcebf">
            Clinical decisions must be made by appropriately qualified professionals within their scope of practice and in accordance with
            applicable laws, regulations, and professional standards.
          </p>
          <p data-id="element-165" data-mp="209m53q4hbcbb">The educational cases are illustrative and should not be interpreted as individualized medical advice or definitive diagnostic protocols.</p>
        </div>
        <div className="mt-8 border-t border-white/10 pt-6 text-sm text-slate-400" data-id="element-166" data-mp="1w67clzzct3gz">
          <p data-id="element-167" data-mp="2sy181eac646a">© 2026 Low Back Pain Assessment Blueprint™. All rights reserved.</p>
          <p className="mt-1" data-id="element-168" data-mp="2o0j462b6ef55">Created by Dr. Ryan Carter.</p>
        </div>
      </div>
    </footer>;
}